import { render, staticRenderFns } from "./OfferTabAI.vue?vue&type=template&id=acefeeb8&scoped=true"
import script from "./OfferTabAI.vue?vue&type=script&lang=js"
export * from "./OfferTabAI.vue?vue&type=script&lang=js"
import style0 from "./OfferTabAI.vue?vue&type=style&index=0&id=acefeeb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acefeeb8",
  null
  
)

export default component.exports